import * as React from 'react'
import { Flex } from '@radix-ui/themes'
import { NutrientModal } from '@/components/subscription/lp/nutrient-modal'
import thumbnail from './images/thumbnail.jpg'
import { styles } from './styles.css'

export const NutrientSection: React.FC = () => {
  return (
    <Flex align="center" justify="center" px="24px" py="40px" className={styles.section}>
      <NutrientModal renderTrigger={() => <img src={thumbnail} className={styles.thumbnail} alt="お花の栄養剤5袋プレゼント中" />} />
    </Flex>
  )
}
